import { render, staticRenderFns } from "./UserFollower.vue?vue&type=template&id=a64cea74&scoped=true&"
import script from "./UserFollower.vue?vue&type=script&lang=js&"
export * from "./UserFollower.vue?vue&type=script&lang=js&"
import style0 from "./UserFollower.vue?vue&type=style&index=0&id=a64cea74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64cea74",
  null
  
)

export default component.exports